import { Maybe } from '@csp/csp-common-model';
import { Page, Paging, largePage } from '@csp/dmdp-api-common-dto';
import { isNotEmpty } from './ArrayUtil';

type GenericPagedResult<T, DataPropName extends string> = {
  [K in DataPropName]?: Array<T>;
} & { paging?: Paging };

async function getAllItems<T, DataPropName extends string>(
  getPage: (page: Page) => Promise<GenericPagedResult<T, DataPropName>>,
  dataPropName: DataPropName,
): Promise<T[]>;
async function getAllItems<T, DataPropName extends string, R>(
  getPage: (page: Page) => Promise<GenericPagedResult<T, DataPropName>>,
  dataPropName: DataPropName,
  mapper: (item: T) => R,
): Promise<R[]>;

async function getAllItems<T, DataPropName extends string, R>(
  getPage: (page: Page) => Promise<GenericPagedResult<T, DataPropName>>,
  dataPropName: DataPropName,
  mapper?: (item: T) => R,
): Promise<R[] | T[]> {
  const result: R[] | T[] = [];
  let loop = true;
  let next: Maybe<string> = undefined;

  do {
    const page: GenericPagedResult<T, DataPropName> = await getPage({ ...largePage(), next });
    const data = page[dataPropName];
    if (mapper && data) {
      (result as R[]).push(...data.map(mapper));
    } else if (data) {
      (result as T[]).push(...data);
    }

    next = page.paging?.next;
    loop = !!next && isNotEmpty(data) && next !== page.paging?.prev;
  } while (loop);

  return result;
}

export const PagedResultUtil = {
  getAllItems,
};
